import { DialogComponent } from '@theme/dialog';

class ModalLocalizationComponent extends DialogComponent {
  openModal = () => {
    this.showDialog();
  };

  handleKeyDown = (event) => {
    if (event.key === 'Tab') {
      this.#handleTabNavigation(event);
    }
  };

  #handleTabNavigation(event) {
    const { dialog } = this.refs;
    if (!dialog.open) return;

    const focusableElements = dialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (firstElement && lastElement) {
      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    }
  }

  handleCountryButtonClick = (event) => {
    if (!event.target) return;
    const button = event.target.closest('.localization-country-button');
    if (!button) return;

    const htmlButton = button;
    const country = htmlButton.dataset.country;
    const language = htmlButton.dataset.language;
    const units = htmlButton.dataset.units;

    if (!country || !language) {
      console.warn('Country button missing required data attributes');
      return;
    }

    const allButtons = this.querySelectorAll('.localization-country-button');
    allButtons.forEach((btn) => btn.classList.remove('selected'));

    button.classList.add('selected');

    this.#handleLocalizationChange(country, language, units);
    setTimeout(() => {
      this.closeDialog();
    }, 300);
  };

  #handleLocalizationChange(country, language, units) {
    const localizationData = {
      country,
      language,
      units,
    };

    console.log('Localization changed:', localizationData);

    this.#submitLocalizationForm(country, language);

    this.dispatchEvent(
      new CustomEvent('localization-changed', {
        detail: localizationData,
        bubbles: true,
      })
    );
    localStorage.setItem('selected-localization', JSON.stringify(localizationData));
  }

  #submitLocalizationForm(country, language) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';

    const countryInput = document.createElement('input');
    countryInput.type = 'hidden';
    countryInput.name = 'country_code';
    countryInput.value = country;
    form.appendChild(countryInput);

    if (language) {
      const primaryLanguage = language.split(',')[0]?.trim();
      if (primaryLanguage) {
        const languageInput = document.createElement('input');
        languageInput.type = 'hidden';
        languageInput.name = 'language_code';
        languageInput.value = primaryLanguage;
        form.appendChild(languageInput);
      }
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    if (csrfToken) {
      const tokenInput = document.createElement('input');
      tokenInput.type = 'hidden';
      tokenInput.name = 'authenticity_token';
      tokenInput.value = csrfToken.content;
      form.appendChild(tokenInput);
    }
    const returnUrlInput = document.createElement('input');
    returnUrlInput.type = 'hidden';
    returnUrlInput.name = 'return_to';
    returnUrlInput.value = window.location.pathname + window.location.search;
    form.appendChild(returnUrlInput);

    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  }

  #initCountryButtons() {
    const countryButtons = this.querySelectorAll('.localization-country-button');
    countryButtons.forEach((button) => {
      button.addEventListener('click', this.handleCountryButtonClick);
    });

    this.#setInitialSelection();
  }

  #setInitialSelection() {
    try {
      const stored = localStorage.getItem('selected-localization');
      if (stored) {
        const { country, language } = JSON.parse(stored);
        const button = this.querySelector(`[data-country="${country}"][data-language*="${language}"]`);
        if (button) {
          button.classList.add('selected');
        }
      }
    } catch (error) {
      console.warn('Could not restore localization selection:', error);
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('keydown', this.handleKeyDown);

    setTimeout(() => {
      this.#initCountryButtons();
    }, 100);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('keydown', this.handleKeyDown);

    const countryButtons = this.querySelectorAll('.localization-country-button');
    countryButtons.forEach((button) => {
      button.removeEventListener('click', this.handleCountryButtonClick);
    });
  }
}

if (!customElements.get('modal-localization-component')) {
  customElements.define('modal-localization-component', ModalLocalizationComponent);
}

export { ModalLocalizationComponent };
